export { default } from './Lottie';
